import Storage from './LocalStorage'
import { DoctorData, UserData } from './Types'

enum Locals {
  ACCESS_TOKEN = 'access_token',
  USER_NAME = 'user_name',
  USER_EMAIL = 'user_email',
  USER_UID = 'user_uid',
  USER_PHOTO = 'user_photo',
  CURRENT_USER = 'current_user',
  CURRENT_DOCTOR = 'current_doctor'
}

export default class UserStorage extends Storage<Locals> {
  private static instance?: UserStorage

  private constructor() {
    super()
  }

  public static getInstance(): UserStorage {
    if (!this.instance) {
      this.instance = new UserStorage()
    }

    return this.instance
  }

  public setToken(tokenId: string) {
    this.set(Locals.ACCESS_TOKEN, tokenId)
  }

  public getTokenId(): string | null {
    return this.get(Locals.ACCESS_TOKEN)
  }

  public setObject(value: Object) {
    this.setItemObject(Locals.CURRENT_USER, value)
  }

  public getObject(): UserData | null {
    return this.getItemObject(Locals.CURRENT_USER) as UserData
  }

  public setDoctor(value: Object) {
    this.setItemObject(Locals.CURRENT_DOCTOR, value)
  }

  public getDoctor(): DoctorData | null {
    return this.getItemObject(Locals.CURRENT_DOCTOR) as DoctorData
  }

  public clear() {
    this.clearStorage()
  }
}
